export default __webpack_public_path__ + "static/website-icon-f89755fbfbad1130ee6c85baf14531ef.png";